import { render, staticRenderFns } from "./MandalaEvaluationsRadarChart.vue?vue&type=template&id=0cbac054&"
import script from "./MandalaEvaluationsRadarChart.vue?vue&type=script&lang=js&"
export * from "./MandalaEvaluationsRadarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports